import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { PageHeader } from '@ant-design/pro-layout';
import { Button, Form, Input, message, Table } from 'antd';
import Title from 'antd/es/typography/Title';
import React, { useState } from 'react';
import { HealthProfessionsData } from '../../../../generated';

interface HealthProfessionDetailsProps {
  healthProfessions: HealthProfessionsData[];
  onSave: (professions: HealthProfessionsData[]) => void;
}

export const HealthProfessionViewContainer: React.FC<HealthProfessionDetailsProps> = ({ healthProfessions, onSave }) => {
  const [selectedProfessions, setSelectedProfessions] = useState<HealthProfessionsData[]>(healthProfessions);
  const [isAddingProfession, setIsAddingProfession] = useState(false);
  const [newProfession, setNewProfession] = useState({ professionCode: '', professionName: '' });

  const handleAddProfession = () => {
    setIsAddingProfession(true);
    setNewProfession({ professionCode: '', professionName: '' });
  };

  const handleRemoveProfession = (index: number) => {
    const updatedProfessions = selectedProfessions.filter((_, i) => i !== index);
    setSelectedProfessions(updatedProfessions);
  };

  const handleProfessionChange = (value: string, field: string) => {
    setNewProfession((prev) => ({ ...prev, [field]: value }));
  };

  const handleSaveProfession = () => {
    let updatedProfessions: HealthProfessionsData[] = [];
    if (selectedProfessions?.length > 0) {
      updatedProfessions = [...selectedProfessions];
    }
    if (isAddingProfession) {
      if (!newProfession.professionCode || !newProfession.professionName) {
        message.error('Profession Code and Profession Name are required.');
        return;
      }

      const isDuplicate = updatedProfessions.some((profession) => profession.professionCode === newProfession.professionCode);
      if (isDuplicate) {
        message.error('Profession Code already exists.');
        return;
      }

      updatedProfessions = [...updatedProfessions, newProfession];
      setSelectedProfessions(updatedProfessions);
      setIsAddingProfession(false);
      setNewProfession({ professionCode: '', professionName: '' });
      onSave(updatedProfessions);
    } else {
      onSave(updatedProfessions);
    }
  };

  const handleCancel = () => {
    setIsAddingProfession(false);
    setNewProfession({ professionCode: '', professionName: '' });
  };

  const professionColumns = [
    {
      title: 'Profession Code',
      dataIndex: 'professionCode',
      key: 'professionCode',
      render: (text: string) => <span>{text}</span>
    },
    {
      title: 'Profession Name',
      dataIndex: 'professionName',
      key: 'professionName',
      render: (text: string) => <span>{text}</span>
    },
    {
      title: 'Action',
      key: 'action',
      render: (_: any, _record: any, index: any) => <MinusCircleOutlined className="dynamic-delete-button" onClick={() => handleRemoveProfession(index)} />
    }
  ];

  return (
    <>
      <PageHeader>
        <div id="leftTitle" style={{ marginBottom: '30px' }}>
          <Title level={3} style={{ display: 'inline' }}>
            Health Professions
          </Title>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Title level={4} type="secondary" style={{ display: 'inline' }}>
            Settings
          </Title>
        </div>
      </PageHeader>
      <div>
        <Table
          rowHoverable={false}
          dataSource={selectedProfessions}
          columns={professionColumns}
          rowKey="professionCode"
          pagination={false}
          style={{ marginBottom: '10px', width: '600px', border: '1px solid #f0f0f0', borderRadius: '10px', padding: '15px' }}
        />
        {isAddingProfession ? (
          <div>
            <Form layout="vertical" style={{ display: 'flex', gap: '10px', width: '600px' }}>
              <Form.Item style={{ flex: 1 }}>
                <Input placeholder="Profession Code" value={newProfession.professionCode} onChange={(e) => handleProfessionChange(e.target.value, 'professionCode')} />
              </Form.Item>
              <Form.Item style={{ flex: 1 }}>
                <Input placeholder="Profession Name" value={newProfession.professionName} onChange={(e) => handleProfessionChange(e.target.value, 'professionName')} />
              </Form.Item>
            </Form>
          </div>
        ) : (
          <Button type="dashed" onClick={handleAddProfession} block style={{ width: '600px', marginBottom: '10px', float: 'inline-start' }}>
            <PlusOutlined /> Add Profession
          </Button>
        )}
        <div style={{ width: '600px', paddingTop: '10px' }}>
          <Button onClick={handleCancel} style={{ marginLeft: '400px' }}>
            Cancel
          </Button>
          <Button type="primary" style={{ marginLeft: '60px' }} onClick={handleSaveProfession}>
            Save
          </Button>
        </div>
      </div>
    </>
  );
};
